import { FC } from "react";
import { useTranslation } from "react-i18next";
import * as Styled from "./overviewComponents";

interface CardInfoItemsProps {
  selected?: string;
  active?: boolean;
}

export const CardInfoItems: FC<CardInfoItemsProps> = ({
  selected,
  active,
}) => {
  const { t } = useTranslation("global");
  const arrayOrder = [1, 2, 3, 4];

  return (
    <Styled.ItemContainer>
      {arrayOrder.map((item, index) => (
        <Styled.ItemsBox key={index}>
          <Styled.ItemsContainer>
            <Styled.ItemTitleBox
              className={
                active ? "animate__animated animate__fadeIn" : " "
              }
            >
              <Styled.BulletPoint
                src={
                  t(
                    `overview${
                      selected ? selected : "software"
                    }Card${item}.img`
                  ) as string
                }
                alt="icon-svg"
              />
              <h2 className="title-medium weight-medium">
                {t(`overview${selected}Card${item}.title`)}
              </h2>
            </Styled.ItemTitleBox>
            <Styled.ItemDescription
              className={
                active
                  ? "body-medium animate__animated animate__fadeIn"
                  : "body-medium"
              }
            >
              {t(`overview${selected}Card${item}.description`)}
            </Styled.ItemDescription>
          </Styled.ItemsContainer>
        </Styled.ItemsBox>
      ))}
    </Styled.ItemContainer>
  );
};
